import { get } from 'lodash'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { request } from '@/utils'

export default {
  namespaced: true,

  state: {
    methods: [],

    showPaymentDialog: false,
    showCreateRecurrentPaymentDialog: false
  },

  mutations: {
    setPaymentsMethods(state, value) {
      state.methods = value
    },

    setShowPaymentDialog(state, value) {
      state.showPaymentDialog = value
    },
    setShowCreateRecurrentPaymentDialog(state, value) {
      state.showCreateRecurrentPaymentDialog = value
    }
  },

  actions: {
    async getPaymentsMethods({ commit, rootState }) {
      try {
        const UserId = get(rootState.account, 'account.id')
        if (UserId) {
          const response = await request.get(joinURLPath(Services.payments, 'methods'), undefined, { UserId })
          if (response) {
            commit('setPaymentsMethods', response)

            return response
          }
        }
      } catch (error) {
        console.error(error)
      }
    },

    setPaymentsMethods({ commit }, value) {
      commit('setPaymentsMethods', value)
    },

    setShowPaymentDialog({ commit }, value) {
      commit('setShowPaymentDialog', value)
    },
    setShowCreateRecurrentPaymentDialog({ commit }, value) {
      commit('setShowCreateRecurrentPaymentDialog', value)
    }
  },

  getters: {
    methods: state => {
      return state.methods
    },
    showPaymentDialog: state => {
      return state.showPaymentDialog
    },
    showCreateRecurrentPaymentDialog: state => {
      return state.showCreateRecurrentPaymentDialog
    }
  }
}
